import { Grid, TextField } from '@mui/material';
import { GridToolbarProps } from '@mui/x-data-grid';
import React from 'react';

import AddRowButton from './AddRowButton';
import BulkSaveButton from './BulkSaveButton';
import { DownloadCsvButton } from './DownloadCsvButton';

export interface GridActionToolbarProps extends Partial<GridToolbarProps> {
  addText?: string;
  handleAdd?: React.MouseEventHandler<HTMLButtonElement>;
  bulkSaveDisabled?: boolean;
  bulkSaveText?: string;
  handleBulkSave?: React.MouseEventHandler<HTMLButtonElement>;
  localSearch: string;
  setLocalSearch: (search: string) => void;
  showCsvExport?: boolean;
}

export const GridActionToolbar: React.FunctionComponent<React.PropsWithChildren<GridActionToolbarProps>> = ({
  addText,
  handleAdd,
  bulkSaveDisabled,
  bulkSaveText,
  handleBulkSave,
  localSearch,
  setLocalSearch,
  showCsvExport,
}) => {
  return (
    <Grid container spacing={2} p={2} justifyContent="space-between">
      <Grid item md={4}>
        <TextField
          fullWidth
          size="small"
          label="Search"
          value={localSearch}
          onChange={(e) => setLocalSearch(e.target.value)}
        />
      </Grid>
      <Grid item>
        <Grid container spacing={1} alignItems="center">
          {showCsvExport && (
            <Grid item>
              <DownloadCsvButton />
            </Grid>
          )}
          {handleAdd && addText && (
            <Grid item>
              <AddRowButton addText={addText} handleAdd={handleAdd} />
            </Grid>
          )}
          {handleBulkSave && bulkSaveText && (
            <Grid item>
              <BulkSaveButton disabled={bulkSaveDisabled} bulkSaveText={bulkSaveText} handleBulkSave={handleBulkSave} />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
